import { useToast } from '@app/core/notifications';
import { GetFragmentDto } from '@mi-front/core';
import { Form } from '@mi-front/ui';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Box, Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../../../../../api';
import { StationsSelect } from '../../../../../../../../components/stations/StationsSelect';
import { useStations } from '../../../../../../../../core/stations/hooks/useStations';

interface Props {
  fragmentId: string;
  fragment: GetFragmentDto;
}

export function ExternalExportStart({ fragment, fragmentId }: Props) {
  const queryClient = useQueryClient();
  const { formatMessage, $t } = useIntl();
  const { notifyInfo, notifyError } = useToast();

  const stations = useStations((s) => Boolean(s.featuresConfig?.export?.enabled));

  return (
    <Box>
      <Form
        initialValues={{
          targetStation: stations.find((s) => s.id === fragment.stationId),
        }}
        actions={() => null}
        onSubmit={async (options) => {
          try {
            await apiClient.fragments.startExternalExport(fragmentId, {
              targetStation: options.targetStation?.id,
            });
            notifyInfo(
              formatMessage({
                id: 'fragments.externalExport.exportStarted',
                defaultMessage: 'Export iniciado',
              }),
            );

            queryClient.invalidateQueries({
              queryKey: ['fragment-export', fragmentId],
            });

            return true;
          } catch (error: any) {
            notifyError(
              $t(
                {
                  id: 'fragments.externalExport.exportStartError',
                  defaultMessage:
                    'An error occurred while starting the export, please contact support (status: {status})',
                },
                { status: error.status },
              ),
            );
            console.log(error);
          }
        }}
      >
        {(fp) => (
          <Box>
            <Box sx={{ maxWidth: 300 }}>
              <StationsSelect
                name={'targetStation'}
                label={formatMessage({
                  id: 'fragments.externalExport.targetStation',
                  defaultMessage: 'Emisora destino',
                })}
                stations={stations}
                maxSelected={1}
                isClearable={false}
              />
            </Box>
            <Button
              color="inherit"
              variant="outlined"
              onClick={fp.submitForm}
              loading={fp.isSubmitting}
              startIcon={<FileUploadIcon />}
            >
              {formatMessage({
                id: 'fragments.exportStatus.initialize',
                defaultMessage: 'Iniciar exportación al almacenamiento configurado',
              })}
            </Button>
          </Box>
        )}
      </Form>
    </Box>
  );
}
